import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileGuard } from '@guards/profile/profile.guard';
import {
  ClientResolver,
  CountriesResolver,
  GroupResolver,
  LocalesResolver,
  MicroFrontendResolver,
  StudentResolver,
  TrailResolver
} from 'core/resolvers';
import { StudentsComponent } from './students/students.component';
import { StudentsImportComponent } from './students-import/students-import.component';
import { StudentCreateComponent } from './student-create/student-create.component';
import { StudentDetailComponent } from './student-detail/student-detail.component';
import { StudentsInviteComponent } from './students-invite/students-invite.component';

const studentsRoutes: Routes = [
  {
    path: 'students',
    title: 'parentStudents',
    resolve: {
      countries: CountriesResolver,
      locales: LocalesResolver,
      trail: TrailResolver
    },
    children: [
      {
        path: '',
        title: 'students',
        component: StudentsComponent,
        resolve: {
          client: ClientResolver
        },
        canActivate: [ProfileGuard],
        data: { action: 'students.list' }
      },
      {
        path: 'new',
        title: 'newStudent',
        component: StudentCreateComponent,
        resolve: {
          group: GroupResolver,
          client: ClientResolver
        },
        canActivate: [ProfileGuard],
        data: { action: 'students.create' }
      },
      {
        path: 'import',
        title: 'importStudent',
        component: StudentsImportComponent,
        resolve: {
          group: GroupResolver,
          client: ClientResolver
        },
        canActivate: [ProfileGuard],
        data: { action: 'students.import' },
        children: [
          {
            path: ':clientId',
            title: 'importStudentClientId',
            component: StudentsImportComponent,
            resolve: {
              client: ClientResolver
            },
            canActivate: [ProfileGuard],
            data: { action: 'students.import' }
          }
        ]
      },
      {
        path: 'invite',
        title: 'inviteStudent',
        component: StudentsInviteComponent,
        resolve: {
          client: ClientResolver
        },
        canActivate: [ProfileGuard],
        data: { action: 'students.invite' },
        children: [
          {
            path: ':clientId',
            title: 'inviteStudentClientId',
            component: StudentsImportComponent,
            resolve: {
              client: ClientResolver
            },
            canActivate: [ProfileGuard],
            data: { action: 'students.invite' }
          }
        ]
      },
      {
        path: ':studentId',
        title: 'studentId',
        resolve: {
          student: StudentResolver
        },
        children: [
          {
            path: '',
            title: 'studentIdDetail',
            component: StudentDetailComponent,
            resolve: {
              client: ClientResolver,
              glreports: MicroFrontendResolver
            },
            canActivate: [ProfileGuard],
            data: { action: 'students.detail', microfrontends: ['GlReports'], preloader: 'secondary' }
          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(studentsRoutes)],
  exports: [RouterModule]
})
export class StudentsRoutingModule {}
